/**
 * Public component
 */
export const ResizablePanel = props => null;